import Button from "../../components/button";
import CustomModal from "../../components/CustomModal";

const AssetDeleteModal = ({
  show = false,
  onClose,
  onConfirm,
  loading = false,
  heading = "Delete Asset",
  message = "Are you sure you want to delete this asset?",
}) => (
  <CustomModal
    show={show}
    handleClose={onClose}
    size="md"
    heading={heading}
    customHeaderCss="custom_header_css"
  >
    <div className="delete_user_modal_body">
      <p>{message}</p>
      <div className="d-flex align-items-center gap-2">
        <Button
          cancelBtn={onClose}
          submitBtn={onConfirm}
          loading={loading}
          disabled={loading}
          buttonExtraCss="delete_user_modal_btn"
          submitText="Delete"
          type="button"
          shouldRow={false}
        />
      </div>
    </div>
  </CustomModal>
);

export default AssetDeleteModal;
